// Project: GSSC Pilot Front-end
// Filename: column_selector.js
// Copyright European Space Agency, 2020
// This file is part of the source code package for contract PO PO 5001024866
// No part of the package, including this file, may be copied, modified,
// propagated, or distributed without prior approval by ESA.
export default class ColumnSelector {
  constructor(label) {
    this.label = label;
  }

  toString() {
    return this.label;
  }
}
